import { render, staticRenderFns } from "./images.vue?vue&type=template&id=2701079e&scoped=true&"
import script from "./images.vue?vue&type=script&lang=js&"
export * from "./images.vue?vue&type=script&lang=js&"
import style0 from "./images.vue?vue&type=style&index=0&id=2701079e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2701079e",
  null
  
)

export default component.exports